import { useState, useRef, useEffect } from "react";
import {
  Button,
  Col,
  Form,
  Row,
  Modal,
  Accordion,
  Table,
} from "react-bootstrap";
import {
  faDownload,
  faPaperclip,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  DeleteRequest,
  GetRequest,
  PostRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { baseURL } from "../../Utils/constants/constant";
import {
  downloadPdf,
  formatDate,
  formatToINR,

  TextWithLineBreaks,
} from "../../Utils/helpers/commonhelper";

import DeleteModal from "../DeleteModal";
import { DetailsQuotationSkeletonLoader } from "../../Utils/skeletonLoader/DetailsQuotationSkeletonLoader";

import { CreateSalesOrder } from "../SalesOrder/CreateSalesOrder";
import { ContactDetails } from "../detailPage/Contacts/ContactDetails";
import { SalesOrderDetailsOffcanvas } from "../SalesOrder/SalesOrderDetailsOffcanvas";
import { CompanyDetails } from "../detailPage/CompanyDetails";
import { DealDetails } from "../deals/DealDetails";
import { useGetRequest } from "../../Utils/hooks/QueryHandler";

export const QuotationDetails = () => {
  const navigate = useNavigate();
  const { quoteID, customerId, quotationNumber } = useParams();
  const [contactId, setContactId] = useState(null);
  const [showContactDetailsOffCanvas, setShowContactDetailsOffCanvas] =
    useState(false);
  const [showDealCanvas, setShowDealCanvas] = useState(false);
  const [showCompanyDetail, setShowCompanyDetail] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [salesOrderDetailsOffcanvas, setSalesOrderDetailsOffcanvas] =
    useState(false);
  const [contactData, setContactData] = useState([]);
  const [isClone, setIsClone] = useState(false);
  const [selectedDealId, setSelectedDealId] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [customer, setCustomer] = useLocalStorageState("customer", {
    token: {},
  });
  const [editData, setEditData] = useState(null);
  const customer_id = customer?.customer_details?.customer_id || 1;
  const token = customer?.token?.authorization || "";
  const rf = customer?.token?.authentication || "";
  const extras = { customer, setCustomer, rf, navigate };
  const headers = {
    Authorization: token,
    Authentication: rf,
  };


  const [quoteData, setQuoteData] = useState([]);
  const [showId, setShowId] = useState(null);
  const [billingAdressData, setBilllingAdress] = useState([]);
  const [shipingAdressData, setshipingAdress] = useState([]);
  const [items, setItem] = useState([]);
  const [departmentToDelete, setDepartmentToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalD, setShowModalD] = useState(false);
  const [modalType, setModalType] = useState(null); // 'approve' or 'reject'
  const [rejectReason, setRejectReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [mailLoading, setMailLoading] = useState(false);
  const [invoiceCalled, setInvoice] = useState(false);
  const [toCancelQuotation, setToCancelQuotation] = useState();
  const [openDescriptions, setOpenDescriptions] = useState({})
  const [isLoading, setIsLoading] = useState(false);
  const handleOpenModal = (type) => {
    setModalType(type);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setRejectReason("");
  };

  const handleConfir = async () => {
    setLoading(true);
    try {
      const payload = {
        quotation_id: quoteID,
        customer_id: customer_id,
        canceletion_reason: rejectReason,
        user_login_id: customer?.customer_details?.id,
      };
      const res = await PutRequest(
        `quotation/cancelQuotation`,
        payload,
        { headers },
        extras
      );
      if (!res || res.status === "fail") {
        return toast.error(res.message || "something went wrong");
      }
      if (res.status === "success") {
        toast.success(res.message);
        setToCancelQuotation();
        setRejectReason("");
        navigate("/quotations");

        setShowModalD(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowModalD(false);
      setLoading(false);
    }
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      let payload;
      if (modalType === "reject") {
        payload = {
          reject_reason: rejectReason,
          quotation_id: quoteID,
          quotation_status: modalType,
        };
      } else {
        payload = {
          reject_reason: "",
          quotation_id: quoteID,
          quotation_status: "approved",
          user_login_id: customer?.customer_details?.id,
        };
      }
      const res = await PutRequest(
        `quotation/changeQuotationStatus`,
        payload,
        { headers },
        extras
      );
      if (res.status !== "success" || res.status === "fail") {
        return toast.error(res.message);
      }
      if (res.status === "success") {
        toast.success(res.message);
        return navigate("/quotations");
      }
    } catch (error) {
      console.error(error, "something went wrong ");
    } finally {
      handleCloseModal();
      setLoading(false);
    }
  };

  //   handleClose for closing the canvas
  const handleCanvasClose = () => {
    setShowContactDetailsOffCanvas(false);
  };

  const handleSalesOrderDetails = async (id) => {
    if (!id) return;
    try {
      const res = await GetRequest(
        `/sales/fetchDetailsOfSpecificOrder/${id}`,
        { headers },
        extras
      );
      if (res.status === "success") {
        const editDataToSet = res.data;
        setEditData(editDataToSet[0]);
        setSalesOrderDetailsOffcanvas(true);

        setIsClone(false);
        setsalesOrderId(id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchQuotationDetailsById = async () => {
    setIsLoading(true);

    try {
      const res = await GetRequest(
        `quotation/fetchDataOfSpecificQuotation/${quoteID}/${customerId}`,
        { headers },
        extras
      );

      if (res.status === "success") {
        setQuoteData(res.data[0]);
        const addresses = JSON.parse(
          res?.data[0]?.company_billing_address || "[]"
        );

        let billingAddress = addresses.find(
          (add) => add.selected === "selected"
        );

        if (!billingAddress) {
          billingAddress = addresses.find((add) => add.for === "shipping");
        }

        if (!billingAddress) {
          billingAddress =
            addresses[0] || JSON.parse(res?.data[0]?.billing_address || "{}");
        }

        const shippingAddress =
          addresses.find((add) => add.for === "shipping") || billingAddress;

        setBilllingAdress(billingAddress);
        setshipingAdress(shippingAddress);

        const itemsArray = JSON.parse(res.data[0]?.items);

        const parsedData = itemsArray.flatMap((entry) => {
          const gstInfo = (entry.gstBreakdown || []).map((gstItem) => ({
            gstRate: gstItem.gst ?? 0,
            gstAmount: gstItem.amount ?? 0,
          }));

          return entry.itemDetails.map((detail) => ({
            productName: detail.name,
            productQuantity: detail.quantity ?? 0,
            productRate: detail.Rate ?? 0,
            productGst: detail.gst ?? 0,
            productDiscount: detail.discount ?? 0,
            productAmount: detail.amount ?? 0,
            productDiscountAmount: detail.discountedAmount ?? 0,
            productDiscountType: detail.discountType ?? 0,
            subTotal: entry["sub-total"] ?? 0,
            specialDiscount: entry["special-discount"] ?? 0,
            grandTotal: entry["grand-total"] ?? 0,
            shippingCharge: entry["shipping_Charge"] ?? 0,
            specialDiscountAmount: entry["special_Discount_Amount"] ?? 0,
            specialDiscountType: entry["special_DiscountType"] ?? 0,
            gstBreakdown: gstInfo,
            productDescription: detail?.itemDescription
          }));
        });

        setItem(parsedData);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchQuotationDetailsById();
  }, [quoteID]);


  const [text, setText] = useState("");
  const [salesOrderId, setsalesOrderId] = useState();


  const [allCompanies, setAllCompanies] = useState([]);


  const [rows, setRows] = useState([{ selected: "Percentage", isOpen: false }]);

  const dropdownRefs = useRef([]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      dropdownRefs.current.forEach((ref, index) => {
        if (ref && !ref.contains(event.target)) {
          setRows((prev) =>
            prev.map((row, i) =>
              i === index ? { ...row, isOpen: false } : row
            )
          );
        }
      });
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const addRow = () => {
    setRows((prev) => [...prev, { selected: "Percentage", isOpen: false }]);
  };

  const handleSelect = (index, label) => {
    setRows((prev) =>
      prev.map((row, i) =>
        i === index ? { ...row, selected: label, isOpen: false } : row
      )
    );
  };

  const toggleDropdown = (index) => {
    setRows((prev) =>
      prev.map((row, i) =>
        i === index ? { ...row, isOpen: !row.isOpen } : row
      )
    );
  };

  const handleItemChange = (selectedItem, rowIndex) => {
    const updatedRows = [...rows];
    updatedRows[rowIndex].item = selectedItem;
    setRows(updatedRows);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: "0.1rem 0.75rem",
      minHeight: "50px",
      backgroundPosition: "right 0.4rem center",
      border: "1px solid #ccc",
    }),

    placeholder: (provided) => ({
      ...provided,
      margin: "1.2rem 0px 0rem",
      fontSize: "0.9rem",
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: "1.2rem 0px 0rem",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      paddingTop: "0.1rem",
      paddingBottom: "0.1rem",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0.25rem",
    }),
  };
  const customStyle = {
    control: (provided) => ({
      ...provided,
      padding: "0rem 0.5rem 0rem",
      minHeight: "35px",
      maxHeight: 38,
      backgroundPosition: "right 0.4rem center",
      border: "1px solid #ccc",
      boxShadow: "none",
    }),

    placeholder: (provided) => ({
      ...provided,
      margin: "0rem 0px 0.2rem",
      fontSize: "0.9rem",
    }),
  };

  const handleDeleteRow = (indexToDelete) => {
    setRows((prev) => prev.filter((_, index) => index !== indexToDelete));
  };

  // Trigger delete modal
  const onDelete = (id) => {
    setDepartmentToDelete(id);
    setShowDeleteModal(true);
  };
  // Confirm delete and call API
  const handleConfirmedDelete = async () => {
    setLoading(true)
    try {
      const res = await DeleteRequest(
        `quotation/deleteQuotation/${departmentToDelete}/${customer?.customer_details?.id}/${customer_id}`,
        { headers },
        extras
      );

      if (res?.status === "success") {
        toast.success(res.message);
        navigate("/quotations");
      } else if (res.status === "fail") {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("Delete error:", error);
    } finally {
      setLoading(false)
      setShowDeleteModal(false);
      setDepartmentToDelete(null);
    }
  };

  const handleCancelQuotatio = (quotation) => {
    if (!quotation) return;

    setToCancelQuotation(quotation.quotation_id);

    setShowModalD(true);
  };

  // const handleCloneClick = async (id) => {
  //   if (!id) return;
  //   try {
  //     const res = await GetRequest(
  //       `/quotation/fetchDataOfSpecificQuotation/${id}/${customer_id}`,
  //       { headers },
  //       extras
  //     );
  //     if (res.status === "success") {
  //       const cloneDataToSet = res.data[0];
  //       setEditData(cloneDataToSet);

  //       setIsEditOpen(true);
  //       setIsClone(true);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  // const [editData, setEditData] = useState(null);
  // const [isEditOpen, setIsEditOpen] = useState(false);
  // const [isClone, setIsClone] = useState(false);

  // const handleEditClick = async (id) => {
  //   if (!id) return;
  //   try {
  //     const res = await GetRequest(
  //       `/quotation/fetchDataOfSpecificQuotation/${id}/${customer_id}`,
  //       { headers },
  //       extras
  //     );
  //     if (res.status === "success") {
  //       const editDataToSet = res.data[0];
  //       setEditData(editDataToSet);
  //       setIsEditOpen(true);
  //       setIsClone(false);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // const handleCloseEdit = () => {
  //   setEditData(null);
  //   setIsEditOpen(false);
  //   setIsClone(false);
  // };

  // if (editData) {
  //   return (
  //     <EditQuotation
  //       data={editData}
  //       isClone={isClone}
  //       isEditOpen={isEditOpen}
  //       setIsEditOpen={setIsEditOpen}
  //       onClose={handleCloseEdit}
  //       quotationId={quoteData.quotation_id}
  //       onRefresh={fetchQuotationDetailsById}
  //     />
  //   );
  // }

  const handleCloseModa = () => {
    setShowModal(false);
    setRejectReason("");
  };

  const handleSendQuotation = async (id) => {
    if (!id) return;
    setMailLoading(true);
    try {
      const payload = {
        quotation_id: id,
        customer_id: customer_id,
      };

      const res = await PostRequest(
        `/quotation/sendQuotation`,
        payload,
        false,
        { headers },
        extras
      );

      if (res.status !== "success" || res.status === "fail") {
        return toast.error(res.message);
      }
      toast.success(res.message);
    } catch (error) {
      console.error(error);
    } finally {
      setMailLoading(false);
    }
  };

  const handleInvoiceClose = () => {
    setInvoice(false);
  };
  const {
    data: pipelineStageData,
    isLoading: isPipelineStageLoading,
    refetch: refetchPipelineStage,
  } = useGetRequest(
    `lead/fetchPipelineStage/${quoteData.pipeline_stage_id}/${customer.customer_details?.customer_id}`,
    ["fetchPipelineStage", quoteData.pipeline_stage_id],
    headers,
    extras,
    {
      enabled: !!quoteData.pipeline_stage_id,
    }
  );

  if (invoiceCalled) {
    if (quoteData?.contact_id) {
      return (
        <CreateSalesOrder
          contact_id={quoteData?.contact_id}
          deal_id={quoteData?.deal_id}
          quotation_id={quoteData?.quotation_id}
          onClose={handleInvoiceClose}
        />
      );
    }
  }

  if (isLoading) {
    return <DetailsQuotationSkeletonLoader />;
  }


  const toggleDescription = (index) => {
    setOpenDescriptions((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  return (
    <>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmedDelete}
        isLoading={loading}
        message="Are you sure you want to delete this item?"
      />

      {mailLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            borderRadius: "inherit",
          }}
        >
          <div className="d-flex flex-column align-items-center">
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: "3rem", height: "3rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="mt-2 text-primary fw-semibold">sending mail</div>
          </div>
        </div>
      )}

      <div
        style={{
          borderRadius: 7,
          background: "#fff",
          height: "calc(100vh - 12vh)",
          border: "1px solid lightblue",
          overflow: "clip",
        }}
      >
        <div
          className="header mb-0 position-sticky top-0 p-3"
          style={{
            borderBottom: "1px solid lightblue",
            zIndex: 11,
            background: "#fff",
          }}
        >
          <div className="d-flex align-center justify-content-between">
            <h3
              className="mb-0"
              style={{
                whiteSpace: "nowrap",
                fontWeight: 300,
                fontSize: "22px",
              }}
            >
              Quotation Details -{" "}
              <span style={{ color: "#0099ff" }}>
                #{quoteData.quotation_number}{" "}
              </span>
            </h3>

            <div className="d-flex align-items-center">
              <div className="me-2" style={{ cursor: "pointer" }} onClick={() => {
                downloadPdf(
                  `${baseURL}/quotation/downloadQuotation/${customer_id}/${quoteID}`,
                  headers,
                  "download",
                  "quotation"
                )
              }}>
                <FontAwesomeIcon
                  icon={faDownload}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginRight: "9px",
                    color: "#5e5f60",
                    cursor: "pointer"
                  }}
                />
                Download
              </div>

              {/* Close Button */}
              <button
                className="btn btn-default-outline ms-3"
                aria-label="Go Back"
                type="button"
                onClick={() => navigate("/quotations")}
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          </div>
        </div>

        <div
          className="form-container"
          style={{
            margin: 0,
            overflowY: "auto",
            height: "100%",
            paddingLeft: "0px",
            paddingTop: "12px",
            position: "relative",
          }}
        >
          {/* <Col md={12} className="px-0"></Col> */}
          <Row className="ms-0 w-100 mb-0">
            <Col md={2} style={{ borderRight: "1px solid #d4e7ed" }}>
              <div style={{ position: "sticky", top: "1rem" }} className="mt-3">
                <ul className=" ps-3" style={{ listStyle: "none" }}>
                  <li className="position-relative border-start ps-3 py-2 pt-0 ps-4">
                    <span
                      className="position-absolute  start-0 translate-middle bg-primary rounded-circle"
                      style={{
                        width: 10,
                        height: 10,
                        top: 11,
                        border: "1px solid #0099ff",
                      }}
                    ></span>
                    <a
                      href="#companyDetailsSection"
                      style={{ color: "#676262" }}
                    >
                      Quotation
                    </a>
                  </li>

                  <li className="position-relative border-start ps-3 py-2 ps-4">
                    <span
                      className="position-absolute top-50 start-0 translate-middle bg-primary rounded-circle"
                      style={{ width: 10, height: 10 }}
                    ></span>
                    <a href="#itemsDetailsSection" style={{ color: "#676262" }}>
                      Items Details
                    </a>
                  </li>
                  <li className="position-relative border-start ps-3 py-2 ps-4">
                    <span
                      className="position-absolute top-50 start-0 translate-middle bg-primary rounded-circle"
                      style={{ width: 10, height: 10 }}
                    ></span>
                    <a
                      href="#termsAndConditionsSec"
                      style={{ color: "#676262" }}
                    >
                      Terms & Conditions
                    </a>
                  </li>
                </ul>
                <hr />
              </div>
            </Col>

            <Col md={10} className="ps-3">
              <div className="ms-0 w-100" id="companyDetailsSection">
                {/* <Row className="ms-0 w-100" style={{ paddingRight: 4 }}> */}
                <div
                  className="ms-0 w-100 p-3"
                  style={{ backgroundColor: "#fbfcff", borderRadius: 4 }}
                >
                  <Row className="pt-3 px-1">
                    <Col md={6}>
                      {" "}
                      <h3
                        // className="mb-4 pt-3"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                          color: "#313131ff",
                        }}
                      >
                        Quotation
                      </h3>
                    </Col>
                    <Col md={6}>
                      {" "}
                      <div className="d-flex align-items-end justify-content-end">
                        <span className="font-small">
                          <span style={{ fontWeight: 200 }}>
                            Quotation Number{" "}
                          </span>
                          <strong className="font-small">
                            #{quoteData.quotation_number}
                          </strong>
                        </span>
                      </div>
                    </Col>
                  </Row>
                  <hr />
                  {/* ROW 1: ADDRESSES (Billing Left, Shipping Right)           */}

                  <Row className="mb-4">
                    {/* Billing Address */}
                    <Col md={6}>
                      <h3
                        className="mb-3"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                          color: "#0099ff",
                        }}
                      >
                        Billing Address
                      </h3>
                      <div
                        className="fs-13 text-dark"
                        style={{ fontWeight: 300 }}
                      >
                        <span
                          className="d-block mb-0"
                          style={{ fontWeight: 600 }}
                        >
                          {quoteData.company_name}
                        </span>
                        {billingAdressData.address}
                        <p
                          className="mt-0 mb-0"
                          style={{ fontWeight: 300, fontSize: 13 }}
                        >
                          {(typeof billingAdressData?.city === "object"
                            ? billingAdressData?.city?.label || billingAdressData?.city?.value
                            : billingAdressData?.city)}
                          ,{" "}
                          {(typeof billingAdressData?.state === "object"
                            ? billingAdressData?.state?.label || billingAdressData?.state?.value
                            : billingAdressData?.state)}
                          ,{" "}
                          {(typeof billingAdressData?.country === "object"
                            ? billingAdressData?.country?.label || billingAdressData?.country?.value
                            : billingAdressData?.country)}
                          - {billingAdressData?.zipcode}
                        </p>
                      </div>
                    </Col>

                    {/* Shipping Address */}
                    <Col md={6}>
                      <h3
                        className="mb-3 ps-2"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                          color: "#0099ff",
                        }}
                      >
                        Shipping Address
                      </h3>
                      <div
                        className="fs-13 text-dark ps-2"
                        style={{ fontWeight: 300 }}
                      >
                        <span
                          className="d-block mb-0"
                          style={{ fontWeight: 600 }}
                        >
                          {quoteData.company_name}
                        </span>
                        {shipingAdressData.address}
                        <p
                          className="mt-0 mb-0"
                          style={{ fontWeight: 300, fontSize: 13 }}
                        >
                          {(typeof shipingAdressData?.city === "object"
                            ? shipingAdressData?.city?.label || shipingAdressData?.city?.value
                            : shipingAdressData?.city)
                            ? (typeof shipingAdressData?.city === "object"
                              ? shipingAdressData?.city?.label || shipingAdressData?.city?.value
                              : shipingAdressData?.city) + ","
                            : ""}{" "}

                          {(typeof shipingAdressData?.state === "object"
                            ? shipingAdressData?.state?.label || shipingAdressData?.state?.value
                            : shipingAdressData?.state)
                            ? (typeof shipingAdressData?.state === "object"
                              ? shipingAdressData?.state?.label || shipingAdressData?.state?.value
                              : shipingAdressData?.state) + ","
                            : ""}{" "}

                          {typeof shipingAdressData?.country === "object"
                            ? shipingAdressData?.country?.label || shipingAdressData?.country?.value
                            : shipingAdressData?.country}{" "}
                          - {shipingAdressData?.zipcode}
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <hr className="my-4" />

                  {/* --------------------------------------------------------- */}
                  {/* ROW 2: DETAILS (Left) & STATUS/DESC (Right)               */}
                  {/* --------------------------------------------------------- */}
                  <Row>
                    <h3
                      className="mb-3"
                      style={{
                        fontWeight: 300,
                        fontSize: "19px",
                        color: "#0099ff",
                      }}
                    >
                      Quote Details
                    </h3>
                    {/* LEFT SIDE: Contact & General Details */}
                    <Col md={6} className=" pe-4">
                      {/* Quotation Number */}
                      {/* <div className="d-flex align-items-center mb-2">
                      <span
                        className="text-secondary fw-medium"
                        style={{ minWidth: "130px", fontSize: "14px" }}
                      >
                        Quotation Number
                      </span>
                      <span className="fw-semibold">
                        #{quoteData.quotation_number}
                      </span>
                    </div> */}

                      {/* Contact Name */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Contact
                        </span>
                        <span
                          className="text-primary cursor-pointer fs-13"
                          style={{ cursor: "pointer", fontWeight: 500 }}
                        // onClick={() => {
                        //   contactId == null
                        //     ? setSalesOrderDetailsOffcanvas(false)
                        //     : setShowContactDetailsOffCanvas(true);
                        // }}
                        >
                          : {quoteData.contact_full_name}
                        </span>
                      </div>

                      {/* Company Name */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Company Name
                        </span>
                        <span
                          className="text-primary  cursor-pointer fs-13"
                          style={{ cursor: "pointer", fontWeight: 500 }}
                        // onClick={() => {
                        //   setSelectedCompanyId(quoteData.company_id);
                        //   setShowCompanyDetail(true);
                        // }}
                        >
                          : {quoteData.company_name || "-"}
                        </span>
                      </div>
                      {/* Reference */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Reference
                        </span>
                        <span className="fs-13" style={{ fontWeight: 500 }}>
                          {" "}
                          : {quoteData.reference_number}
                        </span>
                      </div>

                      {/* Approved By */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Approved By
                        </span>
                        <span
                          className="fs-13"
                          style={{
                            textTransform: "capitalize",
                            fontWeight: 500,
                          }}
                        >
                          : {quoteData.approver_name}
                        </span>
                      </div>

                      {/* Quote Date */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Current Status
                        </span>
                        <span
                          className={`fs-13 ${quoteData.quotation_status === "approved"
                            ? "text-success"
                            : quoteData.quotation_status === "rejected"
                              ? "text-danger"
                              : "text-warning"
                            }`}
                          style={{
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            fontWeight: 500,
                          }}
                        >
                          : {quoteData.quotation_status || "Draft"}
                        </span>
                      </div>
                    </Col>

                    {/* RIGHT SIDE: Status (Top) & Description (Bottom) */}
                    <Col md={6} className=" ps-4">
                      {/* UPPER PART: Status */}

                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Quote Date
                        </span>
                        <span className="fs-13" style={{ fontWeight: 500 }}>
                          {" "}
                          : {formatDate(quoteData.quotation_date)}
                        </span>
                      </div>

                      {/* Expiry Date */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Expiry Date
                        </span>
                        <span className="fs-13" style={{ fontWeight: 500 }}>
                          {" "}
                          : {formatDate(quoteData.expiry_date)}
                        </span>
                      </div>

                      {/* Lead Owner */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Lead Owner
                        </span>
                        <span
                          className="fs-13"
                          style={{
                            textTransform: "capitalize",
                            fontWeight: 500,
                          }}
                        >
                          : {quoteData.owner_name}
                        </span>
                      </div>

                      {/* Deal */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Deal
                        </span>
                        <span
                          className="text-primary fs-13"
                          style={{
                            textTransform: "capitalize",
                            cursor: "pointer",
                            fontWeight: 500,
                          }}
                          onClick={() => {
                            setShowDealCanvas(true);
                            setSelectedDealId(quoteData.deal_id);
                          }}
                        >
                          : {quoteData.deal_name}
                        </span>
                      </div>
                      {/* LOWER PART: Description */}
                      <div className="flex-grow-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Short Description (Subject)
                        </span>
                        <div
                          className="text-break fs-13"
                          style={{ fontWeight: 500 }}
                        >
                          {quoteData?.description || (
                            <span className="text-muted fst-italic">
                              No description provided.
                            </span>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Row
                  style={{
                    width: "100%",
                    marginLeft: 0,
                    paddingRight: 4,
                    marginBottom: "2rem",
                    marginTop: "2rem",
                  }}
                >
                  <Col md={12} className="pe-0 ps-0">
                    <Accordion
                      defaultActiveKey="null"
                      className="sales-order-accordion shadow-none border-0 focus-ring-0 w-100"
                    >
                      <Accordion.Item eventKey="0">
                        <Accordion.Header className="shadow-none border-0 focus-ring-0 bg-transparent">
                          Sales order details
                        </Accordion.Header>

                        <Accordion.Body className="p-0">
                          <div
                            style={{ maxHeight: "300px", overflowY: "auto" }}
                          >
                            <Table className="table-sticky">
                              <thead>
                                <tr>
                                  <th>Sales Order</th>
                                  <th>Owner Name</th>
                                  <th>Order Status</th>
                                  <th>Sales Order Date</th>
                                  <th>Shipment Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {quoteData?.sales_order?.length > 0 ? (
                                  quoteData?.sales_order?.map(
                                    (quote, index) => (
                                      <tr key={index}>
                                        <td
                                          className="text-primary"
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            handleSalesOrderDetails(quote.id)
                                          }
                                        >
                                          {quote.sale_no || "-"}
                                        </td>
                                        <td>{quote.owner_name || "-"}</td>
                                        <td>{quote.order_status || "-"}</td>
                                        <td>
                                          {formatDate(quote.sales_order_date) ||
                                            "-"}
                                        </td>
                                        <td>
                                          {formatDate(quote.shipment_date) ||
                                            "-"}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan={5}> No Data Found</td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                </Row>

                <Row
                  id="itemsDetailsSection"
                  style={{ width: "100%", marginLeft: 0, paddingRight: 4 }}
                >
                  <h3
                    className="ps-0 mb-3"
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: 300,
                      fontSize: "19px",
                      color: "#0099ff",
                    }}
                  >
                    Items Details
                  </h3>

                  <Col md={12} className="pe-0 ps-0">
                    <div className="table-responsive quatationsTables mb-3 ">
                      <table className="table mb-0">
                        <thead>
                          <tr>
                            <th className="text-start">Items Name</th>
                            <th style={{ width: "10%" }} className="text-end">
                              Quantity
                            </th>
                            <th style={{ width: "11%" }} className="text-end">
                              Rate
                            </th>
                            <th style={{ width: "11%" }} className="text-end">
                              GST(
                              <i className="bi bi-percent"></i>)
                            </th>
                            <th style={{ width: "16%" }} className="text-end">
                              Discount(
                              <i className="bi bi-percent"></i>/
                              <i className="ti ti-currency-rupee"></i>)
                            </th>
                            <th
                              style={{ width: "11%" }}
                              className="text-center pe-2"
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((item, index) => (
                            <>
                              <tr key={index}>
                                <td className="text-start">
                                  <div>
                                    <p
                                      className="w-100 mb-0 d-flex fs-15 align-items-center justify-content-between"
                                      style={{ fontWeight: 500 }}
                                    >
                                      {item.productName}
                                    </p>
                                    <p
                                      className="mb-0"
                                      style={{ cursor: "pointer" }}
                                    >
                                      {/* {item.productDiscription || ""} */}
                                      {item.productDescription && (
                                        <div
                                          className="mt-1 d-flex align-items-left"
                                          style={{ cursor: "pointer", color: "#0099ff", fontSize: "12px" }}
                                          onClick={() => toggleDescription(index)}
                                        >
                                          <i
                                            className={`me-1 ${openDescriptions[index] ? "bi bi-x" : "bi bi-plus"
                                              }`}
                                          ></i>
                                          {openDescriptions[index] ? "hide item description" : "show item description"}

                                        </div>
                                      )}
                                    </p>
                                  </div>
                                </td>
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyle}
                                    className="me-2 pt-0"
                                  >
                                    {item?.productQuantity ? `${item?.productQuantity} pcs` : "-"}
                                  </span>
                                </td>
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyle}
                                    className="me-2 pt-0"
                                  >
                                    {item.productRate}
                                  </span>
                                </td>
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyle}
                                    className="me-3 pt-0"
                                  >
                                    {item.productGst}
                                    <i className="bi bi-percent"></i>
                                  </span>
                                </td>
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyle}
                                    className="me-3 pt-0"
                                  >
                                    {item.productDiscount}
                                    {item.productDiscountType === "Percentage" ? (
                                      <i className="bi bi-percent"></i>
                                    ) : (
                                      <i className="ti ti-currency-rupee"></i>
                                    )}
                                  </span>
                                </td>
                                <td className="text-end">
                                  <div className="d-flex gap-2 align-items-center justify-content-end">
                                    <div
                                      className="fs-14 text-end"
                                      style={{ fontWeight: 500, fontSize: 14, paddingRight: "7px", }}
                                    >
                                      {formatToINR(item.productDiscountAmount)}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              {openDescriptions[index] && item.productDescription && (
                                <tr>
                                  <td colSpan={6} className="p-0 border-0">
                                    <div className="px-1 py-2">
                                      <div
                                        className="normalTextarea"
                                        style={{
                                          background: "#f9f9fb",
                                          cursor: "default",
                                          whiteSpace: "pre-wrap",
                                          textAlign: "left"
                                        }}
                                      >
                                        {item.productDescription}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </>
                          ))}

                          <tr>
                            <th
                              className="text-start bg-transparent border-0 vertical-top w-100"
                              style={{ verticalAlign: "top" }}
                            >
                              <div className="mt-1">
                                <p
                                  className="ps-1 mb-2 fs-14"
                                  style={{ fontWeight: 400 }}
                                >
                                  Customer Note
                                </p>
                                <p className=" ps-1 text-wrap fs-13 fw-normal">
                                  {quoteData.customer_note}
                                </p>
                              </div>
                            </th>
                            <th
                              colSpan={5}
                              className="text-start bg-transparent border-0 "
                            >
                              <div
                                className=" w-100 h-100 "
                                style={{
                                  borderRadius: 5,
                                  background: "#f9f9fb",
                                  padding: "1rem 0.6rem",
                                }}
                              >
                                <div className="row sub-total mb-2 text-semibold ">
                                  <div className="total-label col-md-6 fw-500 d-flex align-items-center fs-14">
                                    Sub Total
                                  </div>
                                  <div className="total-amount fs-14 fw-500 text-end text-semibold col-md-6 d-flex align-items-center gap-1 justify-content-end">
                                    {formatToINR(items[0]?.subTotal)}
                                  </div>
                                </div>

                                <div className="row sub-total mb-1">
                                  <div className="total-label col-md-4 d-flex text-secondary align-items-center  fs-13">
                                    Special Discount
                                    <span className="ps-1 text-secondary fw-400 fs-13">
                                      ({items[0]?.specialDiscount}
                                      <span className="pe-1 ">
                                        <i>{items[0]?.specialDiscountType}</i>
                                      </span>
                                      )
                                    </span>
                                  </div>

                                  <div className="total-amount text-end fs-13 text-secondary fw-400 text-semibold col-md-8 d-flex align-items-center justify-content-end">
                                    -{" "}
                                    {formatToINR(
                                      items[0]?.specialDiscountAmount
                                    )}
                                  </div>
                                </div>

                                <div className="row sub-total mb-1">
                                  <div className="total-label col-md-4 d-flex align-items-center fs-13 text-secondary fw-400">
                                    Shipping Charge
                                  </div>
                                  <div className="total-amount text-end text-semibold fs-13 text-secondary fw-400 col-md-8 d-flex align-items-center gap-1 justify-content-end">
                                    {formatToINR(items[0]?.shippingCharge)}
                                  </div>
                                </div>

                                <div>
                                  {[
                                    ...new Map(
                                      items
                                        .flatMap((item) => item.gstBreakdown)
                                        .map((gst) => [gst.gstRate, gst])
                                    ).values(),
                                  ].map((gst) => (
                                    <div
                                      className="row sub-total mb-2"
                                      key={gst.gstRate}
                                    >
                                      <div className="total-label col-md-4  d-flex align-items-center fs-13 text-secondary fw-400">
                                        GST
                                        <span className="ps-1 fs-13 text-secondary fw-400">
                                          ({gst.gstRate}%)
                                        </span>
                                      </div>
                                      <div className="total-amount text-end fs-13 text-secondary fw-400 col-md-8  d-flex align-items-center justify-content-end gap-1">
                                        {formatToINR(
                                          Number(`${gst.gstAmount}`).toFixed(2)
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </div>

                                <hr />
                                <div className="row sub-total text-semibold ">
                                  <div className="total-label fw-500 fs-14 col-md-6">
                                    Grand Total
                                  </div>
                                  <div className="total-amount text-end fs-14 fw-500 col-md-6">
                                    {formatToINR(items[0]?.grandTotal)}
                                  </div>
                                </div>
                              </div>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>

                <Row id="termsAndConditionsSec" className="mt-3">
                  <Col md={8}>
                    <h3
                      className=" mb-3"
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                        color: "#0099ff",
                      }}
                    >
                      Terms & Conditions
                    </h3>

                    <Form.Group className="mb-3" controlId="formTerms">
                      <p
                        className="ps-1 mb-2 fs-13"
                        style={{ fontWeight: 400 }}
                      >
                        {quoteData.terms_condition
                          ? TextWithLineBreaks(quoteData.terms_condition)
                          : "Terms and conditions not available"}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col md={4} className="mb-3">
                    <h3
                      className=" mb-3"
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                        color: "#0099ff",
                      }}
                    >
                      Attachment
                    </h3>
                    <div
                      style={{
                        borderRadius: "10px",
                        padding: "10px 0px",
                        textAlign: "start",
                        width: "100%",
                        maxWidth: "400px",
                        margin: "0px",
                      }}
                    >
                      <p
                        style={{ marginBottom: "5px", color: "#666" }}
                        className="d-flex align-items-center"
                      >
                        <FontAwesomeIcon
                          icon={faPaperclip}
                          className="me-2 fs-20"
                          style={{ color: "#0099ff" }}
                        />
                        {quoteData.attachment ? (
                          <a
                            href={`${baseURL}${quoteData.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#0099ff",
                              textDecoration: "underline",
                            }}
                          >
                            {quoteData.attachment.split("/").pop()}
                          </a>
                        ) : (
                          "No attachment"
                        )}
                      </p>
                    </div>
                  </Col>
                </Row>

                <hr />
              </div>

              <p style={{ height: "5rem" }}>
                <div style={{ marginBottom: "20px", height: "15%" }}>
                  <div className="alert alert-warning mb-5">
                    <div className="d-flex" style={{ gap: "10px" }}>
                      <div>
                        <i
                          className="bi bi-info-circle"
                          style={{ fontSize: "25px" }}
                        ></i>
                      </div>

                      <div>
                        <p>
                          Customize your settings and form fields from Setting
                          ---&gt; Preference
                        </p>
                        <p></p>
                        <p>
                          Choose your Customize Quotation format from Setting
                          ---&gt; Masters --&gt; Templates
                        </p>
                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
              </p>

              <p style={{ height: "10rem" }}></p>

              {/* {location?.state?.key2 && ( */}
              <>
                {/* <div
                    className="bg-white position-sticky "
                    style={{
                      // paddingRight: "17px",
                      // height: 75,
                      // bottom: "1.5px",
                      // right: "20.5px",
                      // display: "flex",
                      // alignItems: "center",
                      // justifyContent: "end",
                      // width: "93.4%",
                      // zIndex: 11,
                      // borderTop: "1px solid lightblue",
                      paddingTop: "13px",
                      paddingBottom: "15px",
                      paddingRight: "17px",
                      // height: 75,
                      bottom: "67.5px",
                      // right: "20.5px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                      // width: "93.4%",
                      zIndex: 11,
                      borderTop: "1px solid lightblue",

                    }}
                  >
                    <Button
                      className="btn btn-default-outline me-2"
                      onClick={() => navigate("/quotations")}
                    >
                      Cancel
                    </Button>

                    <Button
                      className={`${location.state.key2
                        ? "btn btn-danger me-2"
                        : "btn btn-primary me-2"
                        }`}
                      onClick={() => handleOpenModal("reject")}
                    >
                      {location.state.key2 ? "Reject" : ""}
                    </Button>

                    <Button
                      className="btn btn-default"
                      onClick={() => handleOpenModal("approve")}
                    >
                      {location.state.key2 ? "Approve" : ""}
                    </Button>

                    <Modal show={showModal} onHide={handleCloseModal}>
                      <Modal.Header closeButton>
                        <Modal.Title>
                          {modalType === "reject"
                            ? "Confirm Rejection"
                            : "Confirm Approval"}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {modalType === "reject" ? (
                          <>
                            <p>
                              Are you sure you want to reject the quotation?
                            </p>
                            <Form.Group controlId="rejectReason">
                              <Form.Label>Reason</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={3}
                                value={rejectReason}
                                onChange={(e) =>
                                  setRejectReason(e.target.value)
                                }
                              />
                            </Form.Group>
                          </>
                        ) : (
                          <p>Are you sure you want to approve the quotation?</p>
                        )}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          className="btn btn-default-outline me-2"
                          onClick={handleCloseModal}
                        >
                          Cancel
                        </Button>
                        <Button
                          className="btn btn-default"
                          // variant={modalType === "reject" ? "danger" : "success"}
                          onClick={handleConfirm}
                          disabled={
                            modalType === "reject" && rejectReason.trim() === ""
                          }
                        >
                          {loading ? "Submiting.." : "Confirm"}
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div> */}

                <div
                  className="bg-white position-fixed "
                  style={{
                    paddingRight: "17px",
                    height: 75,
                    bottom: "9.5px",
                    right: "20.5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    width: "93.4%",
                    zIndex: 11,
                    borderTop: "1px solid lightblue",
                  }}
                >
                  <Button
                    className="btn btn-default-outline me-2"
                    onClick={() => navigate("/quotations")}
                  >
                    {" "}
                    Cancel
                  </Button>

                  <Button
                    className="btn btn-danger me-2"
                    onClick={() => handleOpenModal("reject")}
                  >
                    Reject
                  </Button>

                  <Button
                    className="btn btn-default"
                    onClick={() => handleOpenModal("approve")}
                  >
                    Approved
                  </Button>

                  <Modal show={showModal} onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                      <Modal.Title>
                        {modalType === "reject"
                          ? "Confirm Rejection"
                          : "Confirm Approval"}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {modalType === "reject" ? (
                        <>
                          <p>Are you sure you want to reject the quotation?</p>
                          <Form.Group controlId="rejectReason">
                            <Form.Label>Reason</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={rejectReason}
                              onChange={(e) => setRejectReason(e.target.value)}
                            />
                          </Form.Group>
                        </>
                      ) : (
                        <p>Are you sure you want to approve the quotation?</p>
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        className="btn btn-default-outline me-2"
                        onClick={handleCloseModal}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="btn btn-default"
                        // variant={modalType === "reject" ? "danger" : "success"}
                        onClick={handleConfirm}
                        disabled={
                          modalType === "reject" && rejectReason.trim() === ""
                        }
                      >
                        {loading ? "Submiting.." : "Confirm"}
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </>
              {/* )} */}
              {showModalD && (
                <Modal show={showModalD} onHide={handleCloseModal}>
                  <Modal.Header closeButton>
                    <Modal.Title>Cancel Quotation</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <>
                      <p>Are you sure you want to cancel the quotation?</p>
                      <Form.Group controlId="rejectReason">
                        <Form.Label>Reason</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={rejectReason}
                          onChange={(e) => setRejectReason(e.target.value)}
                        />
                      </Form.Group>
                    </>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      className="btn btn-default-outline me-2"
                      onClick={handleCloseModa}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn btn-default"
                      onClick={handleConfir}
                      disabled={rejectReason.trim() === ""}
                    >
                      {loading ? "Submiting.." : "Confirm"}
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
            </Col>
          </Row>
        </div>
        {salesOrderDetailsOffcanvas && (
          <SalesOrderDetailsOffcanvas
            // isMyApproval={isMyApproval}
            isEditOpen={isEditOpen}
            setIsEditOpen={setIsEditOpen}
            isClone={isClone}
            // fetchSalesOrder={fetchSalesOrder}
            show={salesOrderDetailsOffcanvas}
            setShowSalesOrderDetails={setSalesOrderDetailsOffcanvas}
            salesDetails={editData}
            // handleCloneClick={handleCloneClick}
            handleClose={() => setSalesOrderDetailsOffcanvas(false)}
          />
        )}

        {showContactDetailsOffCanvas &&
          contactId !== null &&
          contactId !== undefined && (
            <ContactDetails
              show={showContactDetailsOffCanvas}
              setShowId={setShowId}
              onCanvasClose={handleCanvasClose}
              id={contactId}
              allContacts={contactData}
              onlyDetail={true}
            />
          )}
        {showCompanyDetail && selectedCompanyId !== null && (
          <CompanyDetails
            show={showCompanyDetail}
            onCanvasClose={() => setShowCompanyDetail(false)}
            id={selectedCompanyId}
            setShowCompanyDetails={setShowCompanyDetail}
            allCompanies={allCompanies}
            onlyDetails={true}
          />
        )}
        <DealDetails
          show={showDealCanvas}
          onClose={() => setShowDealCanvas(false)}
          dealId={selectedDealId}
          pipelineStageData={pipelineStageData}
          onlyDetail={true}
        />
      </div>

      <style jsx>{`
        // .sales-order-accordion .accordion-button:not(.collapsed) {
        //   // background-color: var(--bs-accordion-active-bg);
        //   box-shadow: inset 0 calc(var(--bs-accordion-border-width) * -1) 0
        //     var(--bs-accordion-border-color);
        //   color: var(--bs-accordion-active-color);
        // }

        .sales-order-accordion .accordion-button:focus {
          border-color: var(--primary03);
          box-shadow: none;
        }

        .sales-order-accordion .accordion-button::after {
          font-family: remixicon !important;
          font-size: 0.8rem;
          line-height: 1;
          background-color: transparent !important;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 3.125rem;
          color: var(--default-text-color);
        }

        .sales-order-accordion .accordion-button {
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
          padding: var(--bs-accordion-btn-padding-y)
            var(--bs-accordion-btn-padding-x);
          font-size: 1rem;
          color: var(--bs-accordion-btn-color);
          text-align: left;
          // background-color: #fff3cd;
          border: 0;
          overflow-anchor: none;
          transition: var(--bs-accordion-transition);
        }

        .table-sticky thead th {
          position: sticky;
          top: 0;
          background: #fff;
          z-index: 10;
        }
      `}</style>
    </>
  );
};

const styles = {
  valuesStyle: {
    marginBottom: 0,
    paddingTop: 4,
    paddingLeft: 0,
    fontSize: "0.87rem",
    lineHeight: 1.6,
    borderRadius: "0.35rem",
    fontWeight: 400,
    color: "black",
  },
  valuesStyle1: {
    marginBottom: 0,
    paddingTop: 25,
    paddingLeft: 13,
    fontSize: "0.87rem",
    lineHeight: 1.6,
    borderRadius: "0.35rem",
    fontWeight: 500,
    color: "black",
    cursor: "pointer",
  },
};
